export default __webpack_public_path__ + "static/media/login.e91b5db8.png";